
    import '/opt/buildhome/repo/packages/x/components/notification/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["notification-demo-hooks","notification-demo-duration","notification-demo-close_tag","notification-demo-static-method"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/notification/index.zh-CN.md?type=demo')
};